import Form from './form';
import TaskStates from '../collection/task.states';

export default Form.extend( {

    events: {
        'click .-add-edit-cancel'() {
            this.trigger( ':possible-value:add-edit-cancel' );
        },

        'click .-add-edit-save'() {
            this.trigger( `:possible-value:${this.options.saveEvent}`,
                this.model.toJSON() );
        },
    },

    serialize() {
        return new TaskStates( [] ).fetch().then( ({ array }) => ({
            states: array, 
            roles: this.options.roles.toJSON(),
            title: this.options.title,
            type: this.options.type,
        }) );
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/config.value.item.mode.edit.js